import React, { memo } from 'react';
import css from './FieldPhoneNumberInternationalInput.module.css';
import { Field } from 'react-final-form';
import PhoneInput from 'react-phone-number-input';
import { useEffect } from 'react';


const PhoneField = memo(({ input: { onChange, value }, label, ...rest }) => {
    return (
        <div className={css.root}>
            {/* <p className={css.label}>{label}</p> */}
            <label>{label}</label>
            <div className={css.inputContainer}>
                <PhoneInput placeholder="" value={value} onChange={p => onChange(p)} {...rest} />
            </div>
        </div>
    );
});

const FieldPhoneNumberInternationalInput = props => {
    const { name, id, label } = props;

    useEffect(() => {
        if (typeof window !== 'undefined') {
            require('react-phone-number-input/style.css');
        }
    }, []);

    return <Field name={name} label={label} component={PhoneField} {...props} />;
};

export default FieldPhoneNumberInternationalInput;